import React from "react"
import _ from "lodash"
import { InputText } from "primereact/inputtext"
import { tryParseFloat } from "data/lib/numbers"

interface NumberEditable {
  rowData: {},
  field: string|any[],
  persist: Function,
  writePrecision?: number,
  className?: string
}

const NumberEdit = (props: NumberEditable) => {
  function update(e:React.FormEvent):void {
    let formVal = (e.target as HTMLInputElement).value
    let val = formVal !== "" ? tryParseFloat(formVal, props.writePrecision) : null
    props.persist(val, props.field, props.rowData, e)
  }

  const defaultVal = _.get(props.rowData, props.field)

  return (
    <InputText
      type="text"
      className={props.className}
      defaultValue={defaultVal ? defaultVal : ""}
      onKeyDown={e => {
        switch(e.key) {
          case "Enter":
            update(e)
            break
          case "Tab":
            update(e)
            break
        }
      }}
      onBlur={e => update(e)}/>
  )
}

export default NumberEdit
